import { useEffect } from 'react'

// NOTE: this page superceeded by /wholesale-agency
const ForRepsPage = () => {
  useEffect(() => {
    document.location.href = '/wholesale-agency'
  }, [])

  return null
}

export default ForRepsPage
